/**
 * @param {String} templateText template string
 * @returns {Function}
 *
 * @see https://medium.com/wdstack/understanding-javascript-micro-templating-f37a37b3b40e
 */
function Templater(templateText) {
  /* eslint-disable */
  return new Function(
    'page',
    'helpers',
    'var output=' +
    JSON.stringify(templateText)
    .replace(/<%=(.+?)%>/g, '"+($1)+"')
    .replace(/<%(.+?)%>/g, '";$1\noutput+="') +
    ';return output;'
  );
}

export default Templater;
